import React, { useEffect, useRef, useState } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Drawer from "@mui/material/Drawer";
import {
  Badge,
  Button,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Modal,
  ThemeProvider,
  Typography,
  createTheme,
} from "@mui/material";
import {
  Close,
  Delete,
  DirectionsCar,
  Home,
  Logout,
  NotificationImportant,
  Notifications,
  People,
  PublishedWithChanges,
  RateReview,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import {
  getNotifications,
  getSignature,
  logout,
  markNotificationAsRead,
  sendSignedUserResponse,
} from "../api/authApi";
import CanvasDraw from "react-canvas-draw";

import { getNotificationsClient } from "../api/clientApi";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { LoadingButton } from "@mui/lab";
import axios from "axios";
const styles = {
  button: {
    height: 50,
    marginTop: 6,
    backgroundColor: "#303030",
    borderRadius: 2,
    alignItems: "center",
    ":hover": {
      bgcolor: "#5c5c5c",
    },
  },
};

export default function Navbar() {
  const [loading, setLoading] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isClearModalOpen, setIsClearModalOpen] = useState(false);
  const [isModalNotificationOpen, setIsModalNotificationOpen] = useState(false);
  const [signatureData, setSignatureData] = useState<string>("");
  const [notificationCount, setNotificationCount] = useState<number>(0);
  const [notifications, setNotifications] = useState<any[]>([]);
  const [selectedNotification, setSelectedNotification] = useState<any>(null);
  const canvasRef = useRef<any>(null);
  const navigate = useNavigate();
  const open = Boolean(anchorEl);

          const token = localStorage.getItem("token");

  useEffect(() => {
    const fetchNotificationCount = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          throw new Error("Token de autenticação não encontrado");
        }

        const totalNotificacao = await getNotificationsClient(token);
        setNotificationCount(totalNotificacao);
      } catch (error) {
        console.error("Erro ao buscar a contagem de notificações:", error);
      }
    };

    fetchNotificationCount();
  }, []);

  useEffect(() => {
  const fetchConfiguracoesUsuario = async () => {
    try {
      const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/config`;
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "ngrok-skip-browser-warning": "true",
        },
      };
      const response = await axios.get(url, config);
      localStorage.setItem("configUsuario", JSON.stringify(response.data));
    } catch (error) {
      console.error("Erro ao buscar configurações do usuário:", error);
    }
  };

  if (token) {
    fetchConfiguracoesUsuario();
  }
}, []);

  const fetchSignature = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("Token de autenticação não encontrado");
      }
      const response = await getSignature(token);
      setSignatureData(response.assinatura);
    } catch (error) {
      console.error("Erro ao buscar a assinatura:", error);
    }
  };

  const handleMenuOpen = () => {
    setOpenDrawer(true);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDrawerClose = () => {
    setOpenDrawer(false);
  };

  const handleNavigateVeiculos = () => {
    navigate("/veiculos");
  };

  const handleNavigateDashboard = () => {
    navigate("/dashboard");
  };

  const handleNavigateClientes = () => {
    navigate("/cliente");
  };

  const handleNavigateTransfer = () => {
    navigate("/transferenciaVeiculos");
  };

  const handleNavigateExcluir = () => {
    navigate("/excluirVeiculo");
  };

  const handleOpenModalSignature = () => {
    setIsModalOpen(true);
    fetchSignature();
  };

  const handleCloseModalSignature = () => {
    setIsModalOpen(false);
  };
  const handleOpenClearModal = () => {
    setIsClearModalOpen(true);
  };

  const handleCloseClearModal = () => {
    setIsClearModalOpen(false);
    setIsModalOpen(false);
  };

  const handleSendResponses = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("Token de autenticação não encontrado");
      }

      const base64 =
        canvasRef.current.canvasContainer.childNodes[1].toDataURL();

      await sendSignedUserResponse(base64, token);

      toast.success("Assinatura salva com sucesso!");

      const response = await getSignature(token);
      setSignatureData(response.assinatura);
    } catch (error) {
      toast.error("Erro ao enviar assinatura do usuário");
    } finally {
      setLoading(false);
    }
    setIsModalOpen(false);
    setIsClearModalOpen(false);
  };

  const handleNotificationClick = async (
    event: React.MouseEvent<HTMLElement>
  ) => {
    setAnchorEl(event.currentTarget);
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("Token de autenticação não encontrado");
      }

      const response = await getNotifications(token);
      setNotifications(response);
    } catch (error) {
      console.error("Erro ao buscar notificações:", error);
    }
  };

  const handleNotificationItemClick = (notification: any) => {
    setSelectedNotification(notification);
    setIsModalNotificationOpen(true);
  };

  const handleModalClose = () => {
    setIsModalNotificationOpen(false);
    setIsClearModalOpen(false);
  };

  const handleMarkAsRead = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token || !selectedNotification) {
        throw new Error(
          "Token de autenticação não encontrado ou notificação não selecionada"
        );
      }

      const success = await markNotificationAsRead(
        token,
        selectedNotification.id
      );

      if (success) {
        setIsModalNotificationOpen(false);
        setIsClearModalOpen(false);

        const updatedNotifications = notifications.map((notification) =>
          notification.id === selectedNotification.id
            ? { ...notification, lida_notificao: true }
            : notification
        );
        setNotifications(updatedNotifications);
        setNotificationCount((prevCount) => prevCount - 1);
        toast.success("Notificação marcada como lida com sucesso!");
      }
    } catch (error) {
      console.error("Erro ao marcar notificação como lida:", error);
      toast.error("Erro ao marcar notificação como lida");
    }
  };

  const defaultTheme = createTheme({
    typography: {
      fontFamily: "Poppins, sans-serif",
    },
  });

  const userDataString = localStorage.getItem("userData");
  const userData = userDataString ? JSON.parse(userDataString) : null;

  const isAdmin = userData && userData.admin === true;

  const handleDrawerItemClick = () => {
    setOpenDrawer(false);
  };

  const handleLogout = async () => {
    try {
      await logout();
      localStorage.clear();
      setTimeout(() => {
        navigate("/");
      }, 800);
    } catch (error) {
      console.error("Erro ao fazer logout:", error);
    }
  };

  const DrawerList = (
    <Box sx={{ width: 250 }} role="presentation">
      <img
        src="../../logoStaff.png"
        alt="Logo da empresa"
        style={{ width: "100%" }}
      />
      <Typography variant="h6" fontWeight={"bold"} textAlign={"center"}>
        Entrega Impecável
      </Typography>
      <Divider sx={{ marginTop: 2 }} />
      <List>
        <ListItem disablePadding onClick={handleNavigateDashboard}>
          <ListItemButton onClick={handleDrawerItemClick}>
            <ListItemIcon>
              <Home />
            </ListItemIcon>
            <ListItemText>Dashboard</ListItemText>
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding onClick={handleNavigateVeiculos}>
          <ListItemButton onClick={handleDrawerItemClick}>
            <ListItemIcon>
              <DirectionsCar />
            </ListItemIcon>
            <ListItemText>Veículos</ListItemText>
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding onClick={handleNavigateClientes}>
          <ListItemButton onClick={handleDrawerItemClick}>
            <ListItemIcon>
              <People />
            </ListItemIcon>
            <ListItemText>Clientes</ListItemText>
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding onClick={handleOpenModalSignature}>
          <ListItemButton>
            <ListItemIcon>
              <RateReview></RateReview>
            </ListItemIcon>
            <ListItemText>Adicionar assinatura</ListItemText>
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding onClick={handleNavigateTransfer}>
          <ListItemButton onClick={handleDrawerItemClick}>
            <ListItemIcon>
              <PublishedWithChanges></PublishedWithChanges>
            </ListItemIcon>
            <ListItemText>Transferência de Veículos</ListItemText>
          </ListItemButton>
        </ListItem>
        {isAdmin && (
          <ListItem disablePadding onClick={handleNavigateExcluir}>
            <ListItemButton onClick={handleDrawerItemClick}>
              <ListItemIcon>
                <Delete />
              </ListItemIcon>
              <ListItemText>Excluir Veículo</ListItemText>
            </ListItemButton>
          </ListItem>
        )}
      </List>
      <Divider />
      <List>
        <ListItem disablePadding onClick={handleLogout}>
          <ListItemButton>
            <ListItemIcon>
              <Logout />
            </ListItemIcon>
            <ListItemText>Logout</ListItemText>
          </ListItemButton>
        </ListItem>
      </List>
    </Box>
  );

  return (
    <ThemeProvider theme={defaultTheme}>
      <Box sx={{ flexGrow: 1, marginBottom: 7 }}>
        <AppBar position="fixed" sx={{ backgroundColor: "#303030" }}>
          <Toolbar>
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="menu"
              sx={{ mr: 2 }}
              onClick={handleMenuOpen}
            >
              <MenuIcon />
            </IconButton>
            <img
              src={userData ? userData.logo_empresa : "../../logoStaff.png"}
              alt="Logo da empresa"
              style={{ width: 140, marginLeft: "auto", marginRight: "auto" }}
            />
            <IconButton color="inherit" onClick={handleNotificationClick}>
              <Badge badgeContent={notificationCount} color="error">
                <Notifications />
              </Badge>
            </IconButton>
          </Toolbar>
        </AppBar>
        <Drawer anchor="left" open={openDrawer} onClose={handleDrawerClose}>
          {DrawerList}
        </Drawer>
      </Box>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {notifications
          .filter((notification) => notification.lida_notificao === false)
          .map((notification) => (
            <MenuItem
              key={notification.id}
              onClick={() => handleNotificationItemClick(notification)}
              sx={{ whiteSpace: "normal", width: { xs: "100%", sm: 400 } }}
            >
              <ListItemIcon>
                <NotificationImportant fontSize="medium" />
              </ListItemIcon>
              <Typography component={"span"}>
                {notification.menssagem_notificacao
                  .split("\n")
                  .map((line: string, index: number) => (
                    <React.Fragment key={index}>
                      {line}
                      <br />
                    </React.Fragment>
                  ))}
                <Divider sx={{ mt: 1 }} variant="middle"></Divider>
              </Typography>
              <Divider variant="middle" sx={{ mt: 2 }} />
            </MenuItem>
          ))}
        {notifications.filter(
          (notification) => notification.lida_notificao === false
        ).length === 0 && (
          <MenuItem disabled>Nenhuma notificação disponível</MenuItem>
        )}
      </Menu>

      <Modal open={isModalOpen}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            border: "2px solid #000",
            boxShadow: 24,
            p: 4,
            width: "80%",
            maxWidth: 800,
            height: "80%",
            maxHeight: 350,
          }}
        >
          <IconButton
            onClick={handleCloseModalSignature}
            sx={{
              position: "absolute",
              top: 10,
              right: 10,
              backgroundColor: "red",
              color: "white",
              ":hover": {
                bgcolor: "#5c5c5c",
              },
            }}
          >
            <Close />
          </IconButton>
          <Typography
            variant="h6"
            color="black"
            height={50}
            sx={{
              paddingTop: "13px",
            }}
          >
            Assinatura do Usuário
          </Typography>

          {signatureData ? (
            <>
              <img
                src={`${process.env.REACT_APP_API_DOMAIN}/storage/${signatureData}`}
                alt="Assinatura"
                style={{
                  maxWidth: "100%",
                  height: "auto",
                  marginBottom: 45,
                }}
              />
              <Button
                variant="contained"
                onClick={handleOpenClearModal}
                sx={{
                  mt: 7,
                  display: "block",
                  margin: "0 auto",
                  backgroundColor: "#303030",
                  ":hover": {
                    bgcolor: "#5c5c5c",
                  },
                }}
              >
                Editar Assinatura
              </Button>
            </>
          ) : (
            <>
              <Box mb={5} display="flex" alignItems="center" borderBottom={2}>
                <CanvasDraw
                  brushColor={"black"}
                  brushRadius={1}
                  canvasWidth={1200}
                  canvasHeight={200}
                  hideInterface={true}
                  hideGrid={true}
                  ref={canvasRef}
                />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: 2,
                  marginBottom: 2,
                }}
              >
                <IconButton
                  onClick={handleCloseModalSignature}
                  sx={{
                    position: "absolute",
                    top: 10,
                    right: 10,
                    backgroundColor: "red",
                    color: "white",
                    ":hover": {
                      bgcolor: "#5c5c5c",
                    },
                  }}
                >
                  <Close />
                </IconButton>
                <LoadingButton
                  loading={loading}
                  onClick={handleSendResponses}
                  variant="contained"
                  sx={{
                    backgroundColor: "#303030",
                    ":hover": {
                      bgcolor: "#5c5c5c",
                    },
                    mr: 5,
                  }}
                >
                  Salvar Assinatura
                </LoadingButton>
                <Button
                  variant="contained"
                  onClick={() => {
                    canvasRef.current.clear();
                  }}
                  sx={{
                    backgroundColor: "#FF0000",
                    ":hover": {
                      bgcolor: "#AA0000",
                    },
                  }}
                >
                  Limpar Assinatura
                </Button>
              </Box>
            </>
          )}
        </Box>
      </Modal>
      <Modal open={isClearModalOpen}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            border: "2px solid #000",
            boxShadow: 24,
            p: 4,
            width: "80%",
            maxWidth: 800,
            height: "auto",
          }}
        >
          <IconButton
            onClick={handleCloseClearModal}
            sx={{
              position: "absolute",
              top: 10,
              right: 10,
              backgroundColor: "red",
              color: "white",
              ":hover": {
                bgcolor: "#5c5c5c",
              },
            }}
          >
            <Close />
          </IconButton>
          <Typography
            variant="h6"
            color="black"
            height={50}
            sx={{
              paddingTop: "13px",
            }}
          >
            Nova Assinatura
          </Typography>
          <Box mb={5} display="flex" alignItems="center" borderBottom={2}>
            <CanvasDraw
              brushColor={"black"}
              brushRadius={1}
              canvasWidth={1200}
              canvasHeight={200}
              hideInterface={true}
              hideGrid={true}
              ref={canvasRef}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: 7,
            }}
          >
            <Grid container spacing={2} justifyContent="space-between">
              <Grid item xs={12} sm={4}>
                <LoadingButton
                  loading={loading}
                  onClick={handleSendResponses}
                  variant="contained"
                  sx={{
                    backgroundColor: "#FF0000",
                    ":hover": {
                      bgcolor: "#AA0000",
                    },
                    width: "100%",
                    height: 70,
                  }}
                >
                  Salvar Assinatura
                </LoadingButton>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Button
                  variant="contained"
                  onClick={() => {
                    canvasRef.current.clear();
                  }}
                  sx={{
                    backgroundColor: "#303030",
                    ":hover": {
                      bgcolor: "#5c5c5c",
                    },
                    width: "100%",
                    height: 70,
                  }}
                >
                  Limpar Assinatura
                </Button>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Button
                  variant="contained"
                  onClick={handleCloseClearModal}
                  sx={{
                    backgroundColor: "#303030",
                    ":hover": {
                      bgcolor: "#5c5c5c",
                    },
                    width: "100%",
                    height: 70,
                  }}
                >
                  Cancelar
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Modal>
      <Modal open={isModalNotificationOpen}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            border: "2px solid #000",
            boxShadow: 24,
            p: 4,
            width: "80%",
            maxWidth: 400,
            textAlign: "center",
          }}
        >
          <Typography variant="h6">
            Deseja marcar a notificação como lida?
          </Typography>
          <Box sx={{ mt: 2 }}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Button
                  variant="contained"
                  fullWidth
                  sx={styles.button}
                  onClick={handleMarkAsRead}
                >
                  Confirmar
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button
                  onClick={handleModalClose}
                  variant="contained"
                  fullWidth
                  sx={styles.button}
                >
                  Cancelar
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Modal>
    </ThemeProvider>
  );
}
